module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-h"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0006-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "h3",
    attrs: {
      "id": "lev173"
    }
  }, [_vm._v("THE RACE HORSE.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("IN Great Britain, the breed of Horses seems to be as mixed as that of its inhabitants. By great attention to the improvement of this noble animal, by a judicious mixture of several kinds, and by superior skill in management, the English Race Horse")]), _c('span', {
    attrs: {
      "href": "#/html/9780226044859_233_not#pg6fn1",
      "id": "rpg6fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*"), _c('sup', [_vm._v("2")])]), _vm._v(" is allowed to excel those of the rest of "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Europe, or perhaps the whole world. For supporting a continuance of violent exertion (or what is called, in the language of the turf, "), _c('em', [_vm._v("bottom)")]), _vm._v(", they are superior to the Arabian, the Barb, or the Persian; and for swiftness, they will yield the palm to none. An ordinary Racer is known to go at the rate of a mile in less than two minutes; but there have been instances of much greater rapidity; the famous Horse, Childers, has been known to move eighty-two feet and a half in a second, or nearly a mile in a minute; he has run round the course at Newmarket, which is little less than four miles, in six minutes and forty seconds.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a3b786e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226044859_10_ch2.vue
// module id = 81
// module chunks = 0